import { Button } from "primereact/button";
import { JVDropdown } from "../../shared/JVDropdown";
import { MultiSelect } from "primereact/multiselect";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Filter, InvoiceTrackingFilter } from "../invoices/Filter";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { Fetch } from "../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

const EmptyFilter = {
    year: null,
    month: null,
    vendor_Company: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    prime_Vendor_Billing_Cycle: null,
    invoiceStatus: null,
    paymentStatus: null,
    dueDateFrom: null,
    dueDateTo: null,
    invoiceNO: "",
    consultant: {
        consultant_ID: 0,
        consultant_Name: ""
    },
};

export const HierarchyList = () => {
    const [invoiceFilter, setInvoiceFilter] = useState<InvoiceTrackingFilter>(EmptyFilter);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const toast = useRef<any>(null);
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        let updateInvoiceFilter: any = invoiceFilter;
        updateInvoiceFilter.vendor_Company = invoiceFilter.vendor_Company?.vendor_Company_ID;
        updateInvoiceFilter.consultantName = invoiceFilter.consultant?.consultant_Name;
        delete updateInvoiceFilter.consultant;
        const response = await Fetch("vwPODetails/getHierarchyList", "GET", null, `filter=` + encodeURIComponent(JSON.stringify(updateInvoiceFilter)), toast);
        if (response) {
            const data: any = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const leftToolbarTemplate = () => {
        return <>
            <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => loadTableData()} />
        </>
    }

    useEffect(() => {
        loadTableData();
    }, [invoiceFilter]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;
    
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter invoiceFilter={invoiceFilter} setReqFilter={(invoiceFilter: InvoiceTrackingFilter) => setInvoiceFilter(invoiceFilter)} toast={toast} byPO_ID={false} fromHierarchyList={true} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt}
                value={tableData.tableData}
                loading={tableData.loading}
                dataKey="invoice_ID"
                paginator
                rows={100}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
            >
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req ID" />
                <Column field="consultant_Name" header="Consultant Name" />
                <Column field="vendor_Company_Name" header="Prime Vendor Company" />
                {/* <Column field="pO_Date" header="PO Date" body={(rowData: any) => {
                    let date;
                    if (rowData.pO_Date) date = format(new Date(rowData.pO_Date), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} /> */}
                <Column field="pO_Date" header="PO Date" body={(rowData: any) => safeFormatDate (rowData.pO_Date, "dd/MM/yyyy", DateFormat)} />
                <Column field="user_Name" header="Name" />
                <Column field="role_Name" header="Role" />
                <Column field="company_Name" header="Company" />
                <Column field="branchName" header="Branch" />
            </DataTable>
            <Toast ref={toast} />
        </>
    );
}